/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * GREEN scores. RED does not, and `reason` says why. WAITING means no state has arrived yet. UNKNOWN means the game has no mode field we can read.
 * @export
 */
export const ScoringHealthStatus = {
    GREEN: 'GREEN',
    RED: 'RED',
    WAITING: 'WAITING',
    UNKNOWN: 'UNKNOWN'
} as const;
export type ScoringHealthStatus = typeof ScoringHealthStatus[keyof typeof ScoringHealthStatus];


export function instanceOfScoringHealthStatus(value: any): boolean {
    for (const key in ScoringHealthStatus) {
        if (Object.prototype.hasOwnProperty.call(ScoringHealthStatus, key)) {
            if (ScoringHealthStatus[key as keyof typeof ScoringHealthStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ScoringHealthStatusFromJSON(json: any): ScoringHealthStatus {
    return ScoringHealthStatusFromJSONTyped(json, false);
}

export function ScoringHealthStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScoringHealthStatus {
    return json as ScoringHealthStatus;
}

export function ScoringHealthStatusToJSON(value?: ScoringHealthStatus | null): any {
    return value as any;
}

export function ScoringHealthStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ScoringHealthStatus {
    return value as ScoringHealthStatus;
}

